import CTA7 from './CTA7'
export default CTA7
